<form [formGroup]="form" (ngSubmit)="submit()" class="baseball-setup">
  <h2>New baseball game</h2>

  <mat-form-field appearance="outline">
    <mat-label>Home team</mat-label>
    <mat-select formControlName="teamId">
      @for (team of teams(); track team.id) {
        <mat-option [value]="team.id">{{ team.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Opponent</mat-label>
    <input matInput formControlName="opponentName" placeholder="Opponent team name" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Home / away</mat-label>
    <mat-select formControlName="homeAway">
      @for (opt of homeAwayOptions; track opt.value) {
        <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Innings</mat-label>
    <input matInput type="number" formControlName="scheduledInnings" min="1" max="12" />
  </mat-form-field>

  <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid">Start game</button>
</form>
